const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT_DATA': {
      const userAnswers = action.data.answers || []

      const answers = state.questions.map((q, id) => {
        const userAnswer = userAnswers.find(el => el.questionId === id)
        return userAnswer !== undefined ? userAnswer.optionId : null
      })
      const visitedQuestions = answers.map(q => q !== null)

      return { ...state, answers, visitedQuestions, userDataLoaded: true }
    }
    case 'SET_SCREEN': {
      return { ...state, currentScreen: action.screen }
    }
    case 'NEXT_QUESTION': {
      const visitedQuestions = [...state.visitedQuestions]
      visitedQuestions[state.selectedQuestion] = true

      const lastQuestion = state.selectedQuestion === state.questions.length - 1
      const selectedQuestion = lastQuestion ? state.selectedQuestion : state.selectedQuestion + 1
      const currentScreen = lastQuestion ? 'message' : state.currentScreen

      const navDirection = selectedQuestion - state.selectedQuestion
      return { ...state, selectedQuestion, visitedQuestions, currentScreen, navDirection }
    }
    case 'PREVIOUS_QUESTION': {
      const selectedQuestion = state.selectedQuestion - 1
      const navDirection = selectedQuestion - state.selectedQuestion
      return { ...state, selectedQuestion, navDirection }
    }
    case 'RESTART': {
      const selectedQuestion = 0
      const answers = state.questions.map(q => null)
      const visitedQuestions = state.questions.map(q => null)
      return { ...state, selectedQuestion, answers, visitedQuestions }
    }
    case 'RESET': {
      const selectedQuestion = 0
      const answers = state.questions.map(q => null)
      const visitedQuestions = state.questions.map(q => null)
      return {
        ...state,
        selectedQuestion,
        answers,
        visitedQuestions,
        currentScreen: 'intro',
        userDataLoaded: false,
      }
    }
    case 'SELECT_QUESTION': {
      return {
        ...state,
        selectedQuestion: action.selectedQuestion,
      }
    }
    case 'SHOW_WELCOME': {
      return {
        ...state,
        showWelcome: action.show,
      }
    }
    case 'UPDATE_ANSWER': {
      const answers = [...state.answers]
      const { selectedQuestion } = state
      answers[selectedQuestion] = action.answer
      return { ...state, answers }
    }
    default:
      return { ...state }
  }
}

export default reducer
